import { render } from "./TriageReferral.vue?vue&type=template&id=5b5c7ea6&scoped=true"
import script from "./TriageReferral.vue?vue&type=script&lang=js"
export * from "./TriageReferral.vue?vue&type=script&lang=js"

import "./TriageReferral.vue?vue&type=style&index=0&id=5b5c7ea6&lang=css"
import "./TriageReferral.vue?vue&type=style&index=1&id=5b5c7ea6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5c7ea6"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QBtn,QExpansionItem,QItemSection,QItemLabel,QTable,QInput,QTd,QTooltip,QDialog,QCard,QCardSection,QSeparator,QCardActions});qInstall(script, 'directives', {ClosePopup});
